
import { OAuth2Client } from '@kolorado/oauth';
import { AxiosResponse } from 'axios';
import { GetParsedMessage } from './types';
import { ParsedResponse } from '../entities/message-parser-v1/parsed-response';
import { axiosInstance } from "../axios-instance";

class MessageParser {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  getParsedMessage(body: GetParsedMessage): Promise<AxiosResponse<ParsedResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<ParsedResponse>(`${this.baseUrl}/parseMessage`, body, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json; charset=utf-8",
      },
    });
  }

  postReplayMessage(input: any): Promise<AxiosResponse> {
    const accessToken = localStorage.getItem('accessToken');
    const { id, replayType, requestedBy, changeTicketNumber } = input;
    const queryParameters = { replayType, requestedBy, changeTicketNumber }
    const request: any = {
      url: `${this.baseUrl}/replayMessage/${id}`,
      params: queryParameters,
      method: 'POST',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    return axiosInstance(request);
  }
}

export default MessageParser;
